import { Theme } from "@mui/system";
import Advantages from "../Advantages/Advantages";
import { BrandName } from "@/core/types/types";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import LogoLink from "@/core/components/LogoLink/LogoLink";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";

const styles = (theme: Theme) => ({
  root: {
    padding: theme.spacing(3),
    width: "100%",
    background: theme.palette.background.default,
    [theme.breakpoints.up("md")]: {
      display: "block",
      "& div": {
        maxWidth: "600px",
        margin: theme.spacing(2, "auto"),
      },
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  rootInitial: {
    minHeight: "calc(100vh - 170px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      minHeight: "calc(100vh - 100px)",
      flexDirection: "row",
    },
  },
  rootInitialSidebar: {
    left: 0,
    zIndex: 1,
    minHeight: "100vh",
    height: "100%",
    width: "340px",
    padding: theme.spacing(3, 4, 2),
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    background: theme.palette.background.default,
  },
  loaderContainer: {
    padding: theme.spacing(2, 2, 4),
    alignSelf: "stretch",
    flexBasis: "100%",
    display: "flex",
    justifyContent: "center",
  },
  rootInitialSidebarTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.spacing(2.5),
    margin: theme.spacing(3, 0, 2),
    fontWeight: 700,
  },
  mobileRoot: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
      padding: theme.spacing(3),
      width: "100%",
      background: theme.palette.background.default,
      "& div": {
        maxWidth: "600px",
        margin: theme.spacing(2, "auto"),
      },
    },
  },
  mobileRootWithMargin: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
      padding: theme.spacing(3),
      width: "100%",
      background: theme.palette.background.default,
      marginTop: "50vh",
      "& div": {
        maxWidth: "600px",
        margin: theme.spacing(2, "auto"),
      },
    },
  },
});

interface UpperFooterProps extends BrandName {
  isSideBarReady?: boolean;
}

export default function UpperFooter({
  brandName,
  isSideBarReady = true,
}: UpperFooterProps) {
  const classes: any = useCustomStyles(styles);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  const mobileRootClass = isSideBarReady
    ? classes.mobileRoot
    : classes.mobileRootWithMargin;

  return (
    <>
      <Box sx={mobileRootClass}>
        <Advantages brandName={brandName} />
      </Box>

      {isLoading ? (
        <Box sx={classes.rootInitial}>
          <Box sx={classes.rootInitialSidebar}>
            <LogoLink brandName={brandName} />
            <div>
              <Box sx={classes?.rootInitialSidebarTitle}>
                {t("common.sidebar.advantages.title")}
              </Box>
              <Advantages brandName={brandName}></Advantages>
            </div>
          </Box>
        </Box>
      ) : (
        <Box sx={classes.root}>
          <Advantages brandName={brandName} />
        </Box>
      )}
    </>
  );
}
